<template>
  <div class="p-t-05">
    <van-row v-for="(item,num) in cataList" :key="num" class="bg-white">
      <div class="cataTitle f-s-8 p-l-75 p-r-75" @click="cataDetial(item)">
        <span
          class="cataTag m-r-8 f-s-6 p-r-3 p-l-3 b-r-6"
          style="height: 0.9rem"
          >{{ item.isLive }}</span
        >
        <van-icon
          :name="activeCata == item.gid ? 'arrow-down' : 'arrow-up'"
          class="f-l-r m-t-10"
        />
        <!-- display:inline-flex -->
        <p style="width: 80%;" class="overFlowTwo f-l-r">
          {{ item.gname }}
        </p>
        
      </div>
      <van-col
        :span="22"
        :offset="1"
        class="videoItem m-t-02 b-r-3"
        v-for="(pojo, index) in item.list"
        :key="index"
        :style="{ display: activeCata == item.gid ? 'block' : 'none' }"
      >
        <van-row class="f-s-6 m-t-04">
          <van-col :span="4">
            <p class="text-c m-t-05" style="
font-family: DINAlternate-Bold, DINAlternate;">{{ Num(index)}}</p>
          </van-col>
          <van-col :span="19">
            <p class="p-b-5 f-s-8" style="color: black">
              {{ pojo.vname }}
            </p>
            <p class="f-s-7 m-b-05" style="color: #73787f">{{ pojo.timelength }}</p>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cataList: [],
      activeCata: "",
    };
  },
  created() {
    this.getCataList();
  },
  methods: {
    Num(index){
      if(index < 10){
        return "0" + (index + 1)
      }
      return index +1
    },
    // 打开或者关闭课程详情
    cataDetial(item) {
      this.activeCata = item.gid;
    },
    getCataList() {
      let data = {
        cid: this.$route.query.cid,
      };
      this.Api({
        url: "api/course/getCourseCatalog",
        method: "POST",
        data,
      }).then((res) => {
        this.cataList = res.data;
        this.activeCata = this.cataList[0].gid;
      });
    },
  },
};
</script>

<style scoped>
.cataTitle {
  height: 3rem;
  line-height: 3rem;
  background: white;
  border-bottom: 1px solid #f4f5f6;
}
.cataTag {
  color: #f08344;
  border: 1px solid #f90011;
}
.videoItem {
  background: #f8f8f8;
}
</style>